// "--:--" --> means the initial calculation on the time has not finished yet. it is the initial value.
// "00:00" --> the count down finished and reached its 0 value;
type Time = '--:--' | '00:00' | `${string | number}:${string | number}`;

export const getTimerText = (
  count: number,
  initialPattern: Time = '00:00'
): Time => {
  if (count <= 0) {
    // countdown has ended
    return initialPattern;
  }

  const hours = Math.floor(count / (60 * 60));
  const remainingSeconds = count - hours * (60 * 60);
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds - minutes * 60;

  // Format minutes and seconds with leading zeros
  return `${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')}`;
};
